import React from 'react';
import styled from 'styled-components';
import DemoVideo from '../../assets/videos/demo.MOV';
import Poster from '../../assets/images/poster.svg';

const Service = () => {
  return (
    <ServiceContainer>
      <ServiceContainerInfo>
        <ServiceContainerBlock>
          <ServiceContainerRound>1</ServiceContainerRound>
          <ServiceContainerText>
            Отсканируй QR код на терминале или скачай приложение
          </ServiceContainerText>
        </ServiceContainerBlock>
        <ServiceContainerBlock>
          <ServiceContainerRound>2</ServiceContainerRound>
          <ServiceContainerText>
            Зарегистрируйся, подтверди номер телефона и привяжи банковскую карту
          </ServiceContainerText>
        </ServiceContainerBlock>
        <ServiceContainerBlock>
          <ServiceContainerRound>3</ServiceContainerRound>
          <ServiceContainerText>
            Найди ближайший терминал в приложении
          </ServiceContainerText>
        </ServiceContainerBlock>
        <ServiceContainerBlock>
          <ServiceContainerRound>4</ServiceContainerRound>
          <ServiceContainerText>
            Отсканируй QR код и возьми пауэрбанк
          </ServiceContainerText>
        </ServiceContainerBlock>
        <ServiceContainerBlock>
          <ServiceContainerRound>5</ServiceContainerRound>
          <ServiceContainerText>
            Верни пауэрбанк в ближайший терминал, просто вставь в свободный слот
          </ServiceContainerText>
        </ServiceContainerBlock>
      </ServiceContainerInfo>
      <ServiceContainerVideo
        poster={Poster}
        src={DemoVideo}
        onClick={(e) => {
          if (e.currentTarget.paused) {
            e.currentTarget.play();
          } else {
            e.currentTarget.pause();
          }
        }}
      />
    </ServiceContainer>
  );
};

const ServiceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1135px) {
    flex-direction: column;
    margin-bottom: -49px;
  }
  @media (max-width: 599px) {
    margin-bottom: 1px;
  }
`;

const ServiceContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
`;

const ServiceContainerBlock = styled.div`
  display: flex;
  margin-bottom: 24px;
  align-items: center;
  &:last-of-type {
    margin-bottom: 0;
  }
  @media (max-width: 599px) {
    align-items: flex-start;
  }
`;

const ServiceContainerText = styled.div`
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  margin-left: 30px;
  width: 68%;
  @media (max-width: 599px) {
    margin-left: 15px;
    width: 83%;
  }
`;

const ServiceContainerRound = styled.div`
  color: #e30613;
  border-radius: 100%;
  width: 72px;
  height: 72px;
  font-weight: 600;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e7e8eb;
  @media (max-width: 599px) {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
`;

const ServiceContainerVideo = styled.video`
  cursor: pointer;
  margin-top: 47px;
  width: 58%;
  height: 331.38px;
  @media (max-width: 1440px) {
    width: 50%;
  }
  @media (max-width: 1135px) {
    width: 100%;
    height: auto;
    margin-top: 55px;
  }
  @media (max-width: 599px) {
    width: auto;
    height: 320px;
  }
`;

export default Service;
